// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
    $(document).ready(function () {
        $(".fileBrowser").on("click", ".folder > a", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var item = $(this);

            if (!item.hasClass("opened")) {
                var others = item.parent().siblings();
                others.add(others.find(".opened")).delay(200).removeClass("opened");
                item.add(item.parent()).addClass("opened");
                if (!item.hasClass("loaded")) {
                    $.ajax({
                        type: "POST",
                        cache: false,
                        url: "/services/marketing/FileBrowserService.asmx/GetFileBrowserData",
                        data: "{ currentItemId: '" + $('.fileBrowser #hfCurrentSitecoreItemId').val() +
                              "', currentLanguage: '" + $('.fileBrowser #hfCurrentLanguage').val() +
                              "', itemId: '" + item.attr("data-id") + "' }",
                        contentType: "application/json; charset=utf-8",
                        success: function (result) {
                            item.addClass("loaded");
                            showFileTree(item.parent(), result.d);
                            //go to opened folder top
                            //jump(item);
                        }
                    });
                } else {
                    //jump(item);
                }
            } else {
                item.add(item.parent()).add(item.parent().find(".opened")).removeClass("opened");
            }
        });

    });

    function showFileTree(item, dataList)
    {
        var links = "<ul>";
        $.each(dataList, function (key, dataItem) {
            if (dataItem.ItemType == 1) {
                links = links + "<li class='folder'><a data-id='" + dataItem.ItemId + "' href='#'>" + dataItem.Name + "</a></li>";
            }
            else {
                links = links + "<li class='item'><a target='_blank' data-filetype='" + dataItem.FileType + "' href='" + dataItem.Link + "'>" + dataItem.Name + "</a></li>";
            }
        });
        links = links + "</ul>";
        item.append(links);
    }

    function jump(el) {
        $('html, body').delay( 200 ).animate({
            scrollTop: $(el).offset().top
        }, 800);
    }

})(window, document, jQuery);